import type { VesselChartPoint } from "../models/vessel-data.models";

// Draws a lightweight SVG series so charting stays dashboard-local and introduces no new package dependency.
const VesselPerformanceChart = ({ points }: { points: VesselChartPoint[] }) => {
  const visible = points
    .filter((point) => point.totalConsumption24h !== null)
    .sort((left, right) => {
      if (left.date === right.date) {
        return left.voyageNumber.localeCompare(right.voyageNumber);
      }

      if (left.date === null) {
        return 1;
      }

      if (right.date === null) {
        return -1;
      }

      return left.date.localeCompare(right.date);
    });

  if (visible.length < 2) {
    return <p className="p-6 text-sm text-gray-500" data-test="vessel-data-chart-empty">No Snowflake chart series is available for this vessel.</p>;
  }

  const values = visible.map((point) => point.totalConsumption24h!);
  const minimum = Math.min(...values);
  const range = Math.max(...values) - minimum || 1;
  const coordinates = visible.map((point, index) => `${(index / (visible.length - 1)) * 720 + 40},${180 - ((point.totalConsumption24h! - minimum) / range) * 130}`).join(" ");

  return (
    <div className="overflow-x-auto p-4" data-test="vessel-data-performance-chart">
      <svg viewBox="0 0 800 220" role="img" aria-label="Total consumption by report date" className="min-w-[650px]">
        <line x1="40" y1="180" x2="760" y2="180" stroke="currentColor" opacity="0.25" />
        <polyline points={coordinates} fill="none" stroke="#008374" strokeWidth="3" />
        {visible.map((point, index) => <circle key={`${point.date}-${index}`} cx={(index / (visible.length - 1)) * 720 + 40} cy={180 - ((point.totalConsumption24h! - minimum) / range) * 130} r="4" fill={point.goodWeather ? "#008374" : "#d97706"}><title>{`${point.date}: ${point.totalConsumption24h} MT`}</title></circle>)}
      </svg>
    </div>
  );
};

export default VesselPerformanceChart;
